<template>
    <div class="widget recent-episode-widget">
        <players-loader
            v-slot:default="{
                players,
                formLoading,
                playersError,
                methods,
            }"
            :api-urls="apiUrls"
            :items-limit="3"
            :items-type="itemsType"
        >
            <widget-header
                players-type="track"
                @change="methods.getPlayers"
            >
                Recent Episode Track Players
            </widget-header>
            <div class="widget-body">
                <ul
                    v-if="
                        ! playersError
                        && (0 < players.length && shows)
                    "
                    class="players-listing"
                >
                    <player-item
                        v-for="player in players"
                        :key="player.hash"
                        :url="`/shows/${player.showHash}/?edit=true&type=${itemsType}&player=${player.trackNo}`"
                        :show-title="showTitle(player.showHash)"
                        :player-title="player.title"
                    />
                </ul>
                <players-messages
                    :form-loading="formLoading"
                    :players-error="playersError"
                    :players="players"
                />
            </div>
        </players-loader>
    </div>
</template>

<script>
import WidgetHeader from './WidgetHeader';
import PlayerItem from './PlayerItem';
import PlayersLoader from './PlayersLoader';
import PlayersMessages from './PlayersMessages';
import { mapState } from 'vuex';

export default {
    components: {
        WidgetHeader,
        PlayerItem,
        PlayersLoader,
        PlayersMessages,
    },

    data: () => ({
        apiUrls: {
            all: '/api/user/episodes',
            show: '/api/shows/{hash}/episodes',
        },
        itemsType: 'track',
    }),

    computed: {
        ...mapState(['shows']),
    },

    methods: {
        /**
         * Returns show title by, given hash
         *
         * @param   {string}  hash  Show hash.
         *
         * @returns  {string}        Show title.
         */
        showTitle(hash) {
            return this.shows[hash]?.title;
        },
    },
};
</script>
